<template>
  <div class="tabs">

    <div class="tabs__item"
      :class="{'tabs__item--active' : active === 'masters'}"
      @click="changeView('masters')">
      <svg class="icon">
        <use xlink:href="/images/svg/symbols.svg#svg-masters"></use>
      </svg>
      {{ $t('controls.masters') }}
    </div>
    <!-- <div class="tabs__item"
         :class="{'tabs__item--active' : active == 'engineers'}"
         @click="changeView('engineers')">
      <svg class="icon">
        <use xlink:href="/images/svg/symbols.svg#svg-engineers"></use>
      </svg>
      {{ $t('controls.engineers') }}
    </div> -->
  </div>
</template>

<script>
export default {
    props: ['active'],
    data() {
        return {}
    },
    methods: {
        changeView(view) {
            this.$emit('changeView', view)
        },
    },
}
</script>
<style lang="scss" scoped>
@import 'src/assets/sass/main';

.tabs {
	display: inline-flex;
	align-items: center;
	&__item {
		width: 110px;
		height: 50px;
		display: flex;
		justify-content: center;
		background-color: #ffffff;
		align-items: center;
		font-size: 14px;
		color: #4d4d4d;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
		box-sizing: border-box;
		cursor: pointer;
		transition: background-color 0.5s;
		border-radius: 8px;

		& .icon {
			width: 20px;
			height: 20px;
			color: $primaryColor;
			margin-right: 11px;
		}
		&--active {
			border: 2px solid #e0e0e0;
			background-color: rgba(97, 66, 45, 0.05);
			box-shadow: none;
			& .icon {
				color: #000;
			}
		}
	}
}
</style>
